export type Environment = "production" | "staging" | "localhost";

export function getEnvironment(): Environment {
	const host = window.location.hostname;

	if (host === "app.eraborn.co") {
		return "production";
	}
	if (host === "dev.eraborn.co") {
		return "staging";
	}
	return "localhost";
}

export function getBetaTagClassName(environment: Environment): string {
	switch (environment) {
		case "production":
			return "betaBadge";
		case "staging":
			return "betaBadgeStaging";
		case "localhost":
			return "betaBadgeLocal";
		default:
			return "betaBadge";
	}
}
